export const ENV = {
  PRODUCTION: {
    KEY: 'production',
    URL: 'https://api.stamurai.com',
  },
  DEVELOPMENT: {
    KEY: 'development',
    URL: 'https://api.staging.stamurai.com',
  },
  LOCAL: {
    KEY: 'local',
    URL: 'http://localhost:8080',
  },
};

export const TASK_TYPES = {
  PRACTICE: 'PRACTICE',
  LEARN: 'LEARN',
  QUIZ: 'QUIZ',
  ASSESSMENT: 'ASSESSMENT',
  MEDITATION: 'MEDITATION',
  TEXT: 'TEXT',
  READING: 'READING',
  VC: 'VC',
  PHONATION_GIVEN_SOUND: 'PHONATION_GIVEN_SOUND',
  URL: 'URL',
  VIDEO: 'VIDEO',
  VIDEO_URL: 'VIDEO_URL',
};

export const BLOCK_TYPES = {
  PRACTICE: 'PRACTICE',
  INTRO: 'INTRO',
  CONCLUSION: 'CONCLUSION',
};

export const TYPE_MAPPINGS = {
  LEARN: TASK_TYPES.LEARN,
  MEDITATION: TASK_TYPES.MEDITATION,
  PRACTICE_MIRROR: TASK_TYPES.PRACTICE,
  PRACTICE_SWT: TASK_TYPES.PRACTICE,
  PULL_OUT_TENSION: TASK_TYPES.PRACTICE,
  TEXT: TASK_TYPES.TEXT,
  ASSESSMENT: TASK_TYPES.ASSESSMENT,
  assessment: TASK_TYPES.ASSESSMENT,
  BREATHING: TASK_TYPES.BREATHING,
  FLEXIBLE_MODELLING: TASK_TYPES.PRACTICE,
  FLEXIBLE_SYLLABLE: TASK_TYPES.PRACTICE,
  PRACTICE_FLEXIBLE_SYLLABLE: TASK_TYPES.PRACTICE,
  PHONATION_GIVEN_SOUND: TASK_TYPES.PHONATION_GIVEN_SOUND,
  READING: TASK_TYPES.READING,
  DAF: TASK_TYPES.PRACTICE,
  DAF_MIRROR: TASK_TYPES.PRACTICE,
  VC: TASK_TYPES.VC,
  QUIZ: TASK_TYPES.QUIZ,
  URL: TASK_TYPES.URL,
  VIDEO: TASK_TYPES.VIDEO,
  VIDEO_URL: TASK_TYPES.VIDEO_URL,
};

export const TASK_TYPE_AND_MODEL_MAPPINGS = {
  [TASK_TYPES.LEARN]: 'LearnExercise',
  [TASK_TYPES.PRACTICE]: 'PracticeExercise',
  [TASK_TYPES.QUIZ]: 'Quiz',
  [TASK_TYPES.ASSESSMENT]: 'Assessment',
  [TASK_TYPES.VIDEO]: 'VideoExercise',
  [TASK_TYPES.VIDEO_URL]: 'VideoExercise',
};

export const WEEK_DAYS_MAPPINGS = {
  SUN: 0,
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
};

export const WEEK_DAYS_REVERSE_MAPPINGS = {
  0: 'SUN',
  1: 'MON',
  2: 'TUE',
  3: 'WED',
  4: 'THU',
  5: 'FRI',
  6: 'SAT',
};

export const ROLES = {
  ADMIN: 'admin',
  // TESTER: 'tester',
  // CRON: 'cron',
  // SERVER: 'server',
  MODERATOR: 'moderator',
  // THERAPIST: 'therapist',
  TELECALLER: 'telecaller',
};

const toolRootPath = 'route://tool';

export const TOOLS = [
  { _id: `${toolRootPath}/breathing`, name: 'Breathing' },
  { _id: `${toolRootPath}/meditation`, name: 'Meditation' },
  { _id: `${toolRootPath}/sounds`, name: 'Sounds' },
  { _id: `${toolRootPath}/reading`, name: 'Reading' },
  { _id: `${toolRootPath}/situation_board`, name: 'Situation Board' },
  { _id: `${toolRootPath}/daily_affirmations`, name: 'Daily Affirmations' },
  { _id: `${toolRootPath}/diaphragmatic_breathing`, name: 'Diaphragmatic Breathing' },
  { _id: `${toolRootPath}/progressive_muscle`, name: 'Progressive Muscle' },
  { _id: `${toolRootPath}/story_mountain`, name: 'Story Mountain' },
  { _id: `${toolRootPath}/autobiography`, name: 'Autobiography' },
  { _id: `${toolRootPath}/future_focused_questions`, name: 'Future Focused Questions' },
  { _id: `${toolRootPath}/future_story_mountain`, name: 'Future Story Mountain' },
  { _id: `${toolRootPath}/repelling_relapse`, name: 'Repelling Relapse' },
  { _id: `${toolRootPath}/invasion_of_new_story`, name: 'Invasion of New Story' },
  { _id: `${toolRootPath}/slowed_down_speech`, name: 'Slowed Down Speech' },
  { _id: `${toolRootPath}/syllable_timed_speech`, name: 'Syllable Timed Speech' },
  { _id: `${toolRootPath}/reduced_demands`, name: 'Reduced Demands' },
  { _id: `${toolRootPath}/stuttering_journal`, name: 'Stuttering Journal' },
  { _id: `${toolRootPath}/beating_bullying`, name: 'Beating Bullying' },
  { _id: `${toolRootPath}/breakup_letter`, name: 'Breakup Letter' },
  { _id: `${toolRootPath}/future_autobiography`, name: 'Future Autobiography' },
  { _id: `${toolRootPath}/situation_practice/interview`, name: 'Situation Practice Interview' },
  { _id: `${toolRootPath}/situation_practice/conversation`, name: 'Situation Practice Conversation' },
  { _id: `${toolRootPath}/situation_practice/hotel_checkin`, name: 'Situation Practice Hotel Checkin' },
  { _id: `${toolRootPath}/situation_practice/library`, name: 'Situation Practice Library' },
  { _id: `${toolRootPath}/situation_practice/gift_shop`, name: 'Situation Practice Gift Shop' },
  { _id: `${toolRootPath}/situation_practice/bakery`, name: 'Situation Practice Bakery' },
  { _id: `${toolRootPath}/situation_practice/doctor_visit`, name: 'Situation Practice Doctor Visit' },
  { _id: `${toolRootPath}/situation_practice/pharmacy`, name: 'Situation Practice Pharmacy' },
  { _id: `${toolRootPath}/cbt`, name: 'CBT Exercise' },
];

export const VIDEO_TYPES = [
  {
    _id: TASK_TYPES.VIDEO, name: TASK_TYPES.VIDEO,
  },
  {
    _id: TASK_TYPES.VIDEO_URL, name: TASK_TYPES.VIDEO_URL,
  },
];

export const VIDEO_URL_ROUTES = [
  {
    _id: 'route://fearedwords', name: 'Feared Words',
  },
];

export const COUNTRY_CODES = {
  Afghanistan: 'AF',
  'Åland Islands': 'AX',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua and Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  'Bolivia:  Plurinational State of': 'BO',
  'Bonaire:  Sint Eustatius and Saba': 'BQ',
  'Bosnia and Herzegovina': 'BA',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  'Brunei Darussalam': 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  Congo: 'CG',
  'Congo:  the Democratic Republic of the': 'CD',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  'CÃ´te d`Ivoire': 'CI',
  Croatia: 'HR',
  Cuba: 'CU',
  'CuraÃ§ao': 'CW',
  Cyprus: 'CY',
  'Czech Republic': 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Ethiopia: 'ET',
  'Falkland Islands (Malvinas)': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island and McDonald Islands': 'HM',
  'Holy See (Vatican City State)': 'VA',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  'Iran:  Islamic Republic of': 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  'Isle of Man': 'IM',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  "Korea:  Democratic People's Republic of": 'KP',
  'Korea:  Republic of': 'KR',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  'Lao People`s Democratic Republic': 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  'Macedonia:  the Former Yugoslav Republic of': 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  'Micronesia:  Federated States of': 'FM',
  'Moldova:  Republic of': 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  'Palestine:  State of': 'PS',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  'RÃ©union': 'RE',
  Romania: 'RO',
  'Russian Federation': 'RU',
  Rwanda: 'RW',
  'Saint BarthÃ©lemy': 'BL',
  'Saint Helena:  Ascension and Tristan da Cunha': 'SH',
  'Saint Kitts and Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin (French part)': 'MF',
  'Saint Pierre and Miquelon': 'PM',
  'Saint Vincent and the Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome and Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  'Sint Maarten (Dutch part)': 'SX',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia and the South Sandwich Islands': 'GS',
  'South Sudan': 'SS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard and Jan Mayen': 'SJ',
  Swaziland: 'SZ',
  Sweden: 'SE',
  Switzerland: 'CH',
  'Syrian Arab Republic': 'SY',
  'Taiwan:  Province of China': 'TW',
  Tajikistan: 'TJ',
  'Tanzania:  United Republic of': 'TZ',
  Thailand: 'TH',
  'Timor-Leste': 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad and Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks and Caicos Islands': 'TC',
  Tuvalu: 'TV',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  'United States Minor Outlying Islands': 'UM',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  'Venezuela:  Bolivarian Republic of': 'VE',
  'Viet Nam': 'VN',
  'Virgin Islands:  British': 'VG',
  'Virgin Islands:  U.S.': 'VI',
  'Wallis and Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};
